import { apiGet, apiPatch } from "@/lib/apiClient";
import type { LeadEntryKind } from "@/lib/crmLeadCreatePayload";

export type CrmDefaultLeadEntry = LeadEntryKind;

export const DEFAULT_CRM_LEAD_ENTRY: CrmDefaultLeadEntry = "account";

let cachedDefaultLeadEntry: CrmDefaultLeadEntry | null = null;

/** Sync default from a prior fetch in this session (avoids New Lead flash on revisit). */
export function getCachedCrmLeadModuleDefaultEntry(): CrmDefaultLeadEntry | null {
  return cachedDefaultLeadEntry;
}

function normalizeDefaultLeadEntry(value: unknown): CrmDefaultLeadEntry {
  return value === "contact" ? "contact" : "account";
}

export type CrmLeadModuleSettingsResponse = {
  orgId?: string;
  defaultLeadEntry?: CrmDefaultLeadEntry;
  updatedAt?: string;
};

export async function fetchCrmLeadModuleSettings(): Promise<CrmDefaultLeadEntry> {
  const res = await apiGet<CrmLeadModuleSettingsResponse>("/api/crm/settings/modules/lead");
  const entry =
    !res.ok || !res.data?.defaultLeadEntry
      ? DEFAULT_CRM_LEAD_ENTRY
      : normalizeDefaultLeadEntry(res.data.defaultLeadEntry);
  cachedDefaultLeadEntry = entry;
  return entry;
}

export async function saveCrmLeadModuleDefaultEntry(
  defaultLeadEntry: CrmDefaultLeadEntry,
): Promise<{ ok: boolean; error?: string }> {
  const res = await apiPatch<CrmLeadModuleSettingsResponse>("/api/crm/settings/modules/lead", {
    defaultLeadEntry,
  });
  if (!res.ok) {
    return { ok: false, error: res.error || "Could not save Lead Entry setting." };
  }
  cachedDefaultLeadEntry = defaultLeadEntry;
  return { ok: true };
}
